import {
  Box,
  Link,
  Icon,
  Text,
  Thumbnail,
  IconButton,
} from '@nimbus-ds/components';
import { EditIcon, TrashIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';
import { useTranslationAccount } from 'domains/Account/hooks';
import { SelectedProductInterface } from 'domains/Catalog/Products/components';

import './SelectedListProducts.scss';

interface SelectedListProductsProps {
  selectedProducts: SelectedProductInterface[];
  onRemoveProduct: (productId: string) => void;
  onOpenModal: () => void;
}

function SelectedListProducts({
  selectedProducts,
  onRemoveProduct,
  onOpenModal,
}: SelectedListProductsProps) {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions.modal');
  return (
    <div className="stratus--margins-expand">
      <div className="stratus--scroll-list">
        <DataList>
          {selectedProducts.map(({ id, name, imageUrl }) => (
            <DataList.Row key={id} padding="none">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                paddingTop="2"
                paddingBottom="2"
                paddingLeft="4"
                paddingRight="4"
              >
                <Box display="flex" gap="2" alignItems="center">
                  <Thumbnail width="56px" src={imageUrl} alt={name} />
                  <Text>{name}</Text>
                </Box>
                <IconButton
                  size="2rem"
                  source={<TrashIcon />}
                  onClick={() => onRemoveProduct(id)}
                />
              </Box>
            </DataList.Row>
          ))}
        </DataList>
      </div>
      <Box paddingTop="4" paddingLeft="4">
        <Link
          appearance="primary"
          as="button"
          textDecoration="none"
          onClick={onOpenModal}
        >
          <Icon color="currentColor" source={<EditIcon />} />
          {t('editProducts')}
        </Link>
      </Box>
    </div>
  );
}

export default SelectedListProducts;
